import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Image } from '../image/image';
import styles from './gallery.module.scss';
const Gallery = ({ gap, gridDimension = [3, 3], imageDimension = 100, children = [], imagesURL = [], imagesALT = [], expandImageOnclick = false, }) => {
    const style = useMemo(() => ({
        '--rc-gallery-gap': `${gap}px`,
        '--rc-gallery-grid-dimension-cols': gridDimension[0],
        '--rc-gallery-grid-dimension-rows': gridDimension[1],
        '--rc-gallery-image-dimension': `${imageDimension}px`,
    }), []);
    const getContent = useMemo(() => {
        const childrenLength = children.length;
        const imagesURLLength = imagesURL.length;
        if (childrenLength) {
            return Array.from({ length: childrenLength }).map((_, index) => (_jsx("span", { children: children[index] }, index)));
        }
        else if (imagesURLLength) {
            return Array.from({ length: imagesURLLength }).map((_, index) => (_jsx(Image, { src: imagesURL[index], expandImageOnClick: expandImageOnclick, alt: imagesALT[index] }, index)));
        }
    }, [children.length, imagesURL?.length]);
    return (_jsx("div", { style: style, className: styles.gallery, children: getContent }));
};
Gallery.displayName = 'Gallery';
export { Gallery };
